import type { Patient, Reference } from '@medplum/fhirtypes'
import { ReferralCode, SNOMED_CT_SYSTEM } from '#src/codeSystems.ts'
import { Order } from '#src/models/orders/Order.ts'
import type { QueryTypes } from '#src/search.ts'

export class ImagingOrder extends Order {
  static byParticipant(params: {
    participant: Reference<Patient>
  }): QueryTypes {
    return {
      code: `${SNOMED_CT_SYSTEM}|${ReferralCode.Imaging}`,
      patient: params.participant,
      _sort: '-_lastUpdated',
      _count: '100',
    }
  }
}
